<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :show-close="false"
    custom-class="fifl-message-box"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <p>설정하신 신규 회원권 기간이 기존 회원권 기간과 일부 중복되어 등록이 불가합니다. 기간이 겹치지 않도록 조정해주시길 바랍니다.</p>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        class="gray"
        @click="handleClickConfirmButton"
      >
        {{ confirmButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
	name: "AlertDialog",
	props: {
		confirmButtonText: {
			type: String,
			default: "확인",
		},
		dialogVisible: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
		},
		message: {
			type: String,
		},
	},
	data() {
		return {};
	},
	computed: {},
	methods: {
		handleClickConfirmButton() {
			this.$emit("confirm");
		},
	},
};
</script>

<style lang="scss">
</style>
